<template>
  <div class="fixed bottom-0 left-0 right-0 bg-takas-koyu py-1.5 px-4 z-40 border-t border-white/5" 
       style="padding-bottom: calc(0.375rem + env(safe-area-inset-bottom));">
    <div class="flex justify-between items-center max-w-md mx-auto">

      <!-- Anasayfa -->
      <router-link to="/" class="flex flex-col items-center space-y-0.5 group relative">
        <div :class="[
          'p-2 rounded-lg transition-all duration-200',
          $route.path === '/'
            ? 'bg-takas-sari/20 scale-110'
            : 'opacity-70 hover:opacity-100 active:scale-95'
        ]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
            :class="['w-5 h-5', $route.path === '/' ? 'text-takas-sari' : 'text-white']">
            <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
            <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
          </svg>
        </div>
        <span :class="[
          'text-[10px] font-medium transition-all duration-200',
          $route.path === '/'
            ? 'text-takas-sari font-semibold'
            : 'text-white/60'
        ]">Ana Sayfa</span>
      </router-link>

      <!-- Keşfet -->
      <router-link to="/category" class="flex flex-col items-center space-y-0.5 group relative">
        <div :class="[
          'p-2 rounded-lg transition-all duration-200',
          $route.path === '/category'
            ? 'bg-takas-sari/20 scale-110'
            : 'opacity-70 hover:opacity-100 active:scale-95'
        ]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
            :class="['w-5 h-5', $route.path === '/category' ? 'text-takas-sari' : 'text-white']">
            <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z" clip-rule="evenodd" />
          </svg>
        </div>
        <span :class="[
          'text-[10px] font-medium transition-all duration-200',
          $route.path === '/category'
            ? 'text-takas-sari font-semibold'
            : 'text-white/60'
        ]">Keşfet</span>
      </router-link>

      <!-- İlan Ver - ORTA BUTON -->
      <router-link to="/add-listing" class="flex flex-col items-center space-y-0.5 group relative -mt-4">
        <div :class="[
          'p-3 rounded-full transition-all duration-200 shadow-lg',
          $route.path === '/add-listing'
            ? 'bg-takas-sari scale-110 ring-2 ring-takas-sari/30'
            : 'bg-takas-sari opacity-90 hover:opacity-100 active:scale-95'
        ]">
          <svg class="w-6 h-6 text-takas-koyu" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <span :class="[
          'text-[10px] font-medium transition-all duration-200 mt-1',
          $route.path === '/add-listing'
            ? 'text-takas-sari font-semibold'
            : 'text-white/60'
        ]">İlan Ver</span>
      </router-link>

      <!-- Takaslarım -->
      <router-link to="/my-trades" class="flex flex-col items-center space-y-0.5 group relative">
        <div :class="[
          'p-2 rounded-lg transition-all duration-200',
          $route.path === '/my-trades'
            ? 'bg-takas-sari/20 scale-110'
            : 'opacity-70 hover:opacity-100 active:scale-95'
        ]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
            :class="['w-5 h-5', $route.path === '/my-trades' ? 'text-takas-sari' : 'text-white']">
            <path d="M7.5 3.75a1.5 1.5 0 0 0-1.5 1.5v.75h12v-.75a1.5 1.5 0 0 0-1.5-1.5h-9Z" />
            <path fill-rule="evenodd" d="M19.5 6.75h-15v10.5a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3V6.75Zm-9 3.75a.75.75 0 0 0-1.5 0v2.25H6.75a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25h2.25a.75.75 0 0 0 0-1.5h-2.25v-2.25Z" clip-rule="evenodd" />
          </svg>
        </div>
        <span :class="[
          'text-[10px] font-medium transition-all duration-200',
          $route.path === '/my-trades'
            ? 'text-takas-sari font-semibold'
            : 'text-white/60'
        ]">Takaslar</span>
      </router-link>

      <!-- Profil -->
      <router-link to="/profile" class="flex flex-col items-center space-y-0.5 group relative">
        <div :class="[
          'p-2 rounded-lg transition-all duration-200',
          $route.path === '/profile'
            ? 'bg-takas-sari/20 scale-110'
            : 'opacity-70 hover:opacity-100 active:scale-95'
        ]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
            :class="['w-5 h-5', $route.path === '/profile' ? 'text-takas-sari' : 'text-white']">
            <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clip-rule="evenodd" />
          </svg>
        </div>
        <span :class="[
          'text-[10px] font-medium transition-all duration-200',
          $route.path === '/profile'
            ? 'text-takas-sari font-semibold'
            : 'text-white/60'
        ]">Profil</span>
      </router-link>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar'
}
</script>